import img1 from '../images/avatar/avt-1.png';
import img2 from '../images/avatar/avt-2.png';
// import img3 from '../images/avatar/avt-3.jpg';
import img4 from '../images/avatar/avt-4.jpg';
import img5 from '../images/avatar/avt-5.png';
import img6 from '../images/avatar/avt-6.png';
import img7 from '../images/avatar/avt-7.png';
import img8 from '../images/avatar/avt-8.png';
import img9 from '../images/avatar/avt-9.png';
import img10 from '../images/avatar/avt-10.png';
import img11 from '../images/avatar/avt-11.png';
import img12 from '../images/avatar/avt-12.png';
import img13 from '../images/avatar/avt-13.png';
import img14 from '../images/avatar/avt-14.png';
import img15 from '../images/avatar/avt-nodeJS.png';
import img16 from '../images/avatar/avt-babel.png';
import img17 from '../images/avatar/avt-aws.png';
import img18 from '../images/avatar/avt-swift.png';
import img19 from '../images/avatar/avt-vite.png';
import img20 from '../images/avatar/avt-bs.png';
import img21 from '../images/avatar/avt-pm.png';
import img22 from '../images/avatar/avt-heroku.png';
import img23 from '../images/avatar/avt-wp.png';
import img24 from '../images/avatar/avt-php.png';
import img25 from '../images/avatar/avt-MySql.png';
import img26 from '../images/avatar/avt-axios.png';
import img27 from '../images/avatar/avt-stackoverflow.png';
// import img28 from '../images/avatar/avt-grunt.png';
import img29 from '../images/avatar/avt-style.png';
import img30 from '../images/avatar/avt-gatsby.png';
import img31 from '../images/avatar/avt-netlify.png';

import imgx from '../images/avatar/avt-3.png';

const topSellerData = [
  {
    img: img1,
    name: 'HTML5',
    // price: "214.2 ETH",
    classPadding: '',
  },
  {
    img: img2,
    name: 'CSS3',
    price: 'Flexbox, Grids',
    classPadding: 'pl-17',
  },
  {
    img: img5,
    name: 'Javascript',
    // price: '170.3 ETH',
    classPadding: 'pl-34',
  },
  {
    img: img15,
    name: 'Node',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img6,
    name: 'React.js',
    // price: '52.8 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img9,
    name: 'MaterialUI',
    // price: '214.2 ETH',
    classPadding: 'pl-68',
  },
  {
    img: img17,
    name: 'Amazon Web Services',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img31,
    name: 'Netlify',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img10,
    name: 'Firebase',
    // price: '38.4 ETH',
    classPadding: 'pl-34',
  },
  {
    img: img7,
    name: 'TS',
    // price: '29.2 ETH',
    classPadding: 'pl-51',
  },
  {
    img: img26,
    name: 'Axios HTTP Requests',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img16,
    name: 'Git',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: imgx,
    name: 'Github',
    // price: '82.79 ETH',
    classPadding: 'pl-68',
  },
  {
    img: img13,
    name: 'NPM',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img20,
    name: 'Boostrap',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img8,
    name: 'Yarn',
    // price: '68.2 ETH',
    classPadding: '',
  },
  {
    img: img19,
    name: 'Vite',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img21,
    name: 'Postman',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img12,
    name: 'MongoDB',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img29,
    name: 'Styled Components',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img11,
    name: 'Serverless',
    // price: '214.2 ETH',
    classPadding: '',
  },
  {
    img: img4,
    name: 'JQuery',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },

  {
    img: img14,
    name: 'Redux State Management',
    // price: '120.7 ETH',
    classPadding: 'pl-51',
  },
  {
    img: img23,
    name: 'Wordpress',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img24,
    name: 'PHP',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img25,
    name: 'MySql',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img27,
    name: 'Stackoverflow',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img22,
    name: 'Heroku ',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },

  {
    img: img30,
    name: 'Gatsby',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
  {
    img: img18,
    name: 'Swift',
    // price: '205.43 ETH',
    classPadding: 'pl-17',
  },
];

export default topSellerData;
